import { Grid, Container, Button, Typography, makeStyles, Card } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import clsx from 'clsx';

// local imports
import { AuthService } from 'app/services';

/* Custom Styles */
const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  composedBg: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '100%',
    zIndex: -1,
    opacity: 0.4,
    filter: `grayscale(75%)`,
    backgroundSize: 'cover',
    backgroundImage: "url('assets/images/backgrounds/pharmacy.jpg')"
  },
  content: {
    position: 'relative',
    zIndex: 5,
    width: '100%'
  }
}));

const LandingPage = () => {
  const classes = useStyles();
  const login = () => AuthService.login();

  return (
    <>
      <div className={clsx(classes.container, 'w-full h-screen flex flex-col ')}>
        <div className="w-full py-8 bg-transparent">
          <img alt="Turp logo" className="w-640 h-160" src="assets/images/logos/turp-01.svg" />
        </div>

        {/* Background image is here */}
        <div className={clsx(classes.composedBg)} />

        {/* Main Content */}
        <div className={clsx('flex-1 flex items-center')}>
          <div className={classes.content}>
            <Container fixed>
              <Grid container spacing={4}>
                <Grid item xs={12} lg={7} xl={6}>
                  <Typography variant="h2" color="primary" className="font-bold ">
                    TURP
                  </Typography>
                  <Typography variant="h3" className="mb-8 font-bold text-gray-800">
                    Yönetim Paneli
                  </Typography>
                  <Typography variant="body1" className="text-16 text-gray-700 break-words">
                    Paneliniz sayesinde eczanelerinize ulaşabilir ve onların bilgilerini
                    yönetebilirsiniz. Nöbetçi eczane listesi oluşturabilirsiniz. Eczanelerinizin
                    siparişlerini ve kampanyalarını, panelinizden kolaylıkla takip edebilirsiniz.
                    Diğer tüm işlemler için lütfen giriş yapınız.
                  </Typography>

                  {/* Divider */}
                  <div className="border-2 border-gray-800 my-16 opacity-25 rounded-full w-160" />

                  <Button
                    size="large"
                    className="py-8 px-32"
                    color="primary"
                    variant="contained"
                    title="Giriş Yap"
                    onClick={login}
                    endIcon={<ArrowForward />}>
                    Giriş Yap
                  </Button>
                </Grid>

                {/* Logo - Illustration */}
                <Grid item xs={12} lg={5} xl={6} className="px-0 hidden lg:flex lg:items-center">
                  <img
                    alt="Welcome Logo"
                    className="w-full"
                    src="assets/images/backgrounds/landing-logo.svg"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>

        {/* Footer */}
        <div className="py-16 px-32 flex items-center space-x-16 justify-end">
          <Typography variant="body1" color="initial">
            Copyright &copy; {new Date().getFullYear()}
          </Typography>
          <a
            className="bg-transparent"
            href="https://ekinokssoftware.com"
            target="_blank"
            rel="noreferrer"
            title="Ekinoks Software">
            TURP | Ekinoks Software
          </a>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
